// extracted by mini-css-extract-plugin
export default {"root":"agenda-list-item_root__M21eQ","link":"agenda-list-item_link__E66tv"};